import { Button } from '@/components/ui/button';

interface ErrorScreenProps {
  error: Error;
  onReset?: () => void;
}

/**
 * ErrorScreen
 * エラー発生時に表示するスクリーン
 */
export function ErrorScreen({ error, onReset }: ErrorScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center max-w-md px-4">
        <h1
          className="text-[#111827] mb-4"
          style={{ fontSize: '24px', fontWeight: 700 }}
        >
          エラーが発生しました
        </h1>
        <p
          className="text-[#6B7280] mb-6"
          style={{ fontSize: '14px', fontWeight: 400, lineHeight: '1.6' }}
        >
          {error.message || '予期せぬエラーが発生しました。'}
        </p>
        {onReset && (
          <Button
            onClick={onReset}
            className="bg-[#0052FF] hover:bg-[#0041CC] text-white px-6 py-3 rounded-lg"
            style={{ fontSize: '14px', fontWeight: 600 }}
          >
            再試行
          </Button>
        )}
      </div>
    </div>
  );
}
